import { Activity } from "lucide-react";
export const QueueInfo = ({ callerInfo }) => {
  console.log(callerInfo, "callerInfocallerInfodsdsdsdsdsdsdsd");
  const renderCommaPills = (value) => {
    if (!value || typeof value !== "string") {
      return <span className="text-white text-xs">--</span>;
    }

    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean)
      .map((item, index) => (
        <span
          key={index}
          style={{
            background: "linear-gradient(135deg, #233580 0%, #902034 100%)",
          }}
          className="inline-flex items-center justify-center
                   min-w-[35px] h-[35px]
                   rounded-lg
                   text-white
                   text-[16px] font-bold
                   border border-white/30
                   shadow-sm"
        >
          {item}
        </span>
      ));
  };

  return (
    <div className="rounded-xl p-4 border-2">
      <h4 className="font-semibold text-gray-900 mb-3  text-xl">Queue Name</h4>
      <div className="flex items-center justify-between p-3 bg-[#E5E7F0] rounded-xl border-2 border-[#902034]">
        <div className="flex items-center space-x-1 border ">
          {renderCommaPills(callerInfo?.callActionInput)}

          <div>
            <p className="font-medium text-gray-900">
              {callerInfo?.callActionQueue ?? "MillWoods TRAVEL EMERGENCY"}
            </p>
          </div>
        </div>
        <span className="px-4 py-1 bg-white text-gray-700 rounded-xl text-sm">
          {callerInfo?.ivrMenuName ?? "Calgary"}
        </span>
      </div>
      <div className="mt-3 flex items-center space-x-2 text-sm text-gray-500 bg-[#ECECF0] py-1 px-2 rounded-xl">
        <Activity className="w-4 h-4" />
        <span>Customer navigated through IVR menu</span>
      </div>
    </div>
  );
};
